"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "HTML5DragTransition", {
  enumerable: true,
  get: function get() {
    return _Transitions.HTML5DragTransition;
  }
});
Object.defineProperty(exports, "TouchTransition", {
  enumerable: true,
  get: function get() {
    return _Transitions.TouchTransition;
  }
});
Object.defineProperty(exports, "MouseTransition", {
  enumerable: true,
  get: function get() {
    return _Transitions.MouseTransition;
  }
});
Object.defineProperty(exports, "createTransition", {
  enumerable: true,
  get: function get() {
    return _createTransition.default;
  }
});
Object.defineProperty(exports, "PreviewList", {
  enumerable: true,
  get: function get() {
    return _PreviewList.PreviewList;
  }
});
Object.defineProperty(exports, "MultiBackend", {
  enumerable: true,
  get: function get() {
    return _MultiBackend.default;
  }
});
exports.default = void 0;

var _Transitions = require("./Transitions");

var _createTransition = _interopRequireDefault(require("./createTransition"));

var _PreviewList = require("./PreviewList");

var _MultiBackend = _interopRequireDefault(require("./MultiBackend"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(manager, context, options) {
  return new _MultiBackend.default(manager, context, options);
};

exports.default = _default;